import React, { useRef, useEffect, useState, useCallback } from 'react';
import * as webService from "./WebService"

/* 
{"connections":[{"name":"taskId","from":"outmmu0xui3","to":"6ppmmu0y80b"},{"from":"outmmu0xui3","to":"4a3mmu0z7tw","name":"categoryId"},{"from":"outmmu0xui3","to":"siommu0zd9s","name":"groupId"},{"from":"outmmu0xui3","to":"ym6mmu41yl1","name":"context"},{"from":"ym6mmu41yl1","to":"ym6mmu41yl1","name":""},{"from":"outmmu0xui3","to":"4lvmmu0yrr6","name":"isManual"},{"from":"4a3mmu0z7tw","to":"4lvmmu0yrr6","name":""},{"from":"6ppmmu0y80b","to":"4lvmmu0yrr6","name":""},{"from":"siommu0zd9s","to":"4lvmmu0yrr6","name":""},{"from":"ym6mmu41yl1","to":"4lvmmu0yrr6","name":""},{"from":"6ppmmu0y80b","to":"xqhmmu4ij3p","name":"scheduleId"},{"from":"4a3mmu0z7tw","to":"xqhmmu4ij3p","name":"scheduleId"},{"from":"xqhmmu4ij3p","to":"4lvmmu0yrr6","name":""}],"nodes":[{"id":"outmmu0xui3","type":"field","name":"ListActivity"},{"name":"TaskActivity","id":"6ppmmu0y80b","type":"field"},{"name":"AlarmActivity","id":"4lvmmu0yrr6","type":"field"},{"name":"CategoryActivity","type":"field","id":"4a3mmu0z7tw"},{"type":"field","id":"siommu0zd9s","name":"GroupActivity"},{"id":"ym6mmu41yl1","name":"StatActivity","type":"field"},{"id":"xqhmmu4ij3p","name":"scheduleActivity","type":"field"}],"locationNodes":[{"id":"outmmu0xui3","x":571,"y":51},{"id":"6ppmmu0y80b","x":58,"y":289},{"y":689,"id":"4lvmmu0yrr6","x":578},{"y":219,"id":"4a3mmu0z7tw","x":409},{"y":324,"id":"siommu0zd9s","x":511},{"id":"ym6mmu41yl1","x":928,"y":272},{"id":"xqhmmu4ij3p","x":312,"y":379}]}
*/

const nodeHeight = 20;
const yMarg = 10;
const xMarg = 10;
const xPadding = 50;
const lineAdjustment = 2;
const debounceInterval = 500

const Web = ({ initialData, update, exit, editing, edit }) => {

	const canvasWrapperRef = useRef(null)
	const canvasRef = useRef(null)
	const ctxRef = useRef(null)
	const mirrorRef = useRef(null)
	const mirrorSizeRef = useRef(null)

	const actionRef = useRef("1")
	const [action, setAction] = useState("1")

	let state = constructModel(initialData?.data, initialData?.locationData)
	const [dataInternal, setDataInternal] = useState(state)

	const stateRef = useRef({
		mouseState: webService.MouseState.UP,
		mouseContext: {},
		selectionContext: {},
		model: state

	})

	const [mirrorText, setMirrorText] = useState("")
	const [copyState, setCopyState] = useState("Copy Image")
	const [downloadState, setDownloadState] = useState("Download")

	const lastClickTimeRef = useRef(0)

	//setup listeners when editing
	useEffect(() => {
		console.log("Web useEffect")
		console.log("Initial data Web: " + JSON.stringify(initialData))

		const canvas = canvasRef.current
		const ctx = setAndGetCtx()
		ctx.lineWidth = 2;
		ctx.lineCap = "round";
		function addListeners() {
			canvas?.addEventListener('pointerdown', onMouseDown);
			canvas?.addEventListener('pointermove', onMouseMove);
			// canvas.addEventListener('click', onCanvasClick);
			document.addEventListener('pointerup', onMouseUp);
			mirrorRef.current.addEventListener('pointerdown', mirrorClick)
		}

		function removeListeners() {
			canvas?.removeEventListener('pointerdown', onMouseDown);
			canvas?.removeEventListener('pointermove', onMouseMove);
			// canvas.removeEventListener('click', onCanvasClick);
			document.removeEventListener('pointerup', onMouseUp);
			mirrorRef.current?.removeEventListener('pointerdown', mirrorClick)
		}

		const doubleClickThreshold = 300
		let lastClick = 0

		function mirrorClick() {
			let time = Date.now()
			stateRef.current.mouseState = webService.MouseState.DOWN_ON_MIRROR
			if (time - lastClick < doubleClickThreshold) {
				console.log("Mirror Double Clicked", time, time - lastClick)
				lastClick = 0
				stateRef.current.selectionContext = {}
				updateMirror()
			} else {
				console.log("Mirror Clicked", time)
				stateRef.current.selectionContext.clickedId = null
				lastClick = time
			}
		}

		if (editing) {
			addListeners();
		}

		clearCtx()

		return () => {
			if (editing) {
				removeListeners();
			}
		};
	}, [editing])

	const setMirrorPosition = useCallback(() => {
		if (mirrorRef.current) {
			mirrorSizeRef.current.textContent = mirrorText || ' ';
			const width = mirrorSizeRef.current.offsetWidth + 20; // padding
			mirrorRef.current.style.width = `${width}px`;

			const height = mirrorSizeRef.current.scrollHeight + 20; // padding
			mirrorRef.current.style.height = `${height}px`;

			let x, y;
			if (stateRef.current.mouseState === webService.MouseState.DRAGGING_NODE) {
				makeInvisible(mirrorRef.current)
				return
			} else if (stateRef.current.selectionContext.selectedLocationNode) {
				makeVisible(mirrorRef.current)
				x = stateRef.current.selectionContext.selectedLocationNode.x - (width / 2)
				y = stateRef.current.selectionContext.selectedLocationNode.y - (height / 2)

			} else if (stateRef.current.selectionContext.selectedConnection) {
				makeVisible(mirrorRef.current)
				let coor = webService.getConnectionCoordinates(stateRef.current.selectionContext.selectedConnection, stateRef.current.model)
				x = coor[0]
				y = coor[1]
			} else {
				makeInvisible(mirrorRef.current)
				return
			}

			const canvas = canvasRef.current
			const mirror = mirrorRef.current;

			const rect = canvas.getBoundingClientRect();
			if (actionRef.current === '1') {
				mirror.style.left = (x + rect.left + 3) + 'px';
				mirror.style.top = (y + rect.top + 3) + 'px';
			} else {
				mirror.style.left = -1000 + 'px'
				mirror.style.top = 0 + 'px'
			}
		}
	}, [mirrorText])

	/**
	 * Strips all browser styling to make the editor blend 
	 * perfectly with the Canvas background.
	 */
	const makeInvisible = (el) => {
		if (!el) return;

		el.style.display = 'none'

		// const style = el.style;
		// style.background = 'transparent';
		// style.border = 'none';
		// style.outline = 'none';
		// style.boxShadow = 'none';
		// style.padding = '0';
		// style.margin = '0';
		// style.resize = 'none';
		// style.appearance = 'none';
		// style.WebkitAppearance = 'none';

		// // We keep the caret (cursor) visible so the user can see where they are
		// style.caretColor = 'black';
		// // Set color to 'transparent' if you are drawing the text on canvas in real-time
		// style.color = 'black';
	};

	/**
	 * Restores default styling. 
	 * Highy useful for debugging alignment and "click-zone" issues.
	 */
	const makeVisible = (el) => {
		if (!el) return;

		const style = el.style;
		style.display = 'block'

		style.background = 'white';
		style.border = '1px solid #007bff'; // A nice blue "edit mode" border
		style.outline = 'auto';
		style.boxShadow = '0px 0px 5px rgba(0,0,0,0.2)';
		style.padding = '2px';

		// Reset colors to ensure readability
		style.color = 'black';
		style.caretColor = 'black';
	};

	const updateMirror = useCallback((text) => {
		setMirrorText(text)
		setMirrorPosition()
	}, [setMirrorPosition, setMirrorText])

	const drawNode = useCallback((ctx, lines, x, y, type, bold = false) => {
		try {
			// console.log("drawNode " + x + " : " + y)
			let width = 0
			ctx.font = "10.6px Arial"
			for (let line of lines) {
				width = Math.max(width, ctx.measureText(line).width)
			}
			let height = nodeHeight * lines.length
			ctx.fillStyle = 'white'
			if (bold) {
				ctx.lineWidth = 4
			} else {
				ctx.lineWidth = 1
			}
			switch (type) {
				case "topic":
					ctx.beginPath();
					ctx.moveTo(x + (0.5 * xMarg), -0.6 * nodeHeight + y);
					ctx.lineTo(x + width - (0.5 * xMarg), -0.6 * nodeHeight + y);
					ctx.arc(x + width - (0.5 * xMarg), -0.6 * nodeHeight + y + (0.5 * nodeHeight), 0.5 * nodeHeight, 1.5 * Math.PI, 0.5 * Math.PI);
					ctx.lineTo(x + (0.5 * xMarg), -0.6 * nodeHeight + y + nodeHeight);
					ctx.arc(x + (0.5 * xMarg), -0.6 * nodeHeight + y + (0.5 * nodeHeight), 0.5 * nodeHeight, 0.5 * Math.PI, 1.5 * Math.PI);
					ctx.stroke();
					break;
				case "idea":
					ctx.save();
					ctx.translate(x, y)
					ctx.scale((width + (2 * xMarg)) / height, 1);
					ctx.beginPath();
					ctx.arc(0, 0, height / 2, 0, 2 * Math.PI);
					ctx.restore();
					ctx.fill()
					ctx.stroke();
					break;
				case "field":
					ctx.strokeRect(x - (0.5 * (width + xMarg)), y - (0.5 * height), width + xMarg, height);
					ctx.fillRect(x - (0.5 * (width + xMarg - ctx.lineWidth)), y - (0.5 * (height - ctx.lineWidth)), width + xMarg - ctx.lineWidth, height - ctx.lineWidth)
					break;
				default:
					ctx.beginPath();
					ctx.moveTo(x + (0.5 * width), -0.6 * nodeHeight + y);
					ctx.lineTo(x + (0.5 * width), -0.6 * nodeHeight + y + nodeHeight);
					ctx.stroke();
					break;
			}
			ctx.fillStyle = 'black'
			let startY = y + lineAdjustment + ((nodeHeight - height) / 2)
			for (let line of lines) {
				ctx.fillText(line, x - (width / 2), startY);
				startY += 16
			}
		} catch (e) {
			console.log("ERROR: ", e)
		}

	}, [])

	const getDimensions = useCallback(() => {
		let maxX = 0;
		let maxY = 0;

		for (let node of stateRef.current.model.locationNodes) {
			if (node.x > maxX) {
				maxX = node.x
			}
			if (node.y > maxY) {
				maxY = node.y
			}
		}

		return { width: maxX, height: maxY }
	}, [stateRef])

	const setCanvasDimensions = useCallback((canvas) => {
		let { width, height } = getDimensions()

		let mouseX = stateRef.current.mouseContext.x
		if (mouseX == null) {
			mouseX = 0
		}
		let mouseY = stateRef.current.mouseContext.y
		if (mouseY == null) {
			mouseY = 0
		}

		canvas.width = Math.max(200, width + 100, mouseX + 100);
		canvas.height = Math.max(200, height + 100, mouseY + 100);
		canvasWrapperRef.current.style.height = canvas.height + "px"
	}, [getDimensions])

	const drawTree = useCallback(() => {
		let canvas = canvasRef.current
		let ctx = ctxRef.current
		if (ctx == null) {
			ctx = getCtx()
		}

		setCanvasDimensions(canvas);

		ctx.fillStyle = 'white'
		ctx.fillRect(0, 0, canvas.width, canvas.height)
		ctx.fillStyle = 'black'

		for (let connection of stateRef.current.model.connections) {
			let fromLocation = stateRef.current.model.locationNodes.find(n => {
				return n.id === connection.from
			})
			let toLocation = stateRef.current.model.locationNodes.find(n => n.id === connection.to)

			if (connection === stateRef.current.selectionContext.selectedConnection) {
				ctx.lineWidth = 4
			} else {
				ctx.lineWidth = 1
			}

			// Line start and end points
			const x1 = fromLocation.x
			const y1 = fromLocation.y
			const x2 = toLocation.x
			const y2 = toLocation.y

			ctx.beginPath();
			ctx.moveTo(x1, y1);
			ctx.lineTo(x2, y2);
			ctx.stroke();
			ctx.save()
			ctx.translate(x2 - (0.25 * (x2 - x1)), y2 - (0.25 * (y2 - y1)))
			ctx.rotate(Math.atan2(y2 - y1, x2 - x1))
			ctx.beginPath()
			ctx.lineTo(-5, 5)
			ctx.lineTo(-5, -5)
			ctx.lineTo(0, 0)
			ctx.restore()
			ctx.fill()
		}

		for (let connection of stateRef.current.model.connections) {
			let [x, y] = webService.getConnectionCoordinates(connection, stateRef.current.model)

			if (connection.name.trim().length > 0) {
				drawNode(ctx, [connection.name], x, y, "idea", connection === stateRef.current.selectionContext.selectedConnection)
			}
		}

		for (let node of stateRef.current.model.nodes) {
			let location = stateRef.current.model.locationNodes.find(n => {
				return n.id === node.id
			})

			let to = 0
			let from = 0
			for (let connection of stateRef.current.model.connections) {
				if (connection.to === node.id) {
					let newTo = parseFloat(connection.name)
					if (!Number.isNaN(newTo)) {
						to += newTo
						to = roundToTwo(to)
					}

				} else if (connection.from === node.id) {
					let newFrom = parseFloat(connection.name)
					if (!Number.isNaN(newFrom)) {
						from += newFrom
						from = roundToTwo(from)
					}
				}
			}

			let lines = node.name.split('\n')

			if (to > 0 && from > 0) {
				let net = roundToTwo(to - from)
				if (net !== 0) {
					lines.push(`Net: ${net}`)
				}
			}

			drawNode(ctx, lines, location.x, location.y, node.type, node.id === stateRef.current.selectionContext.selectedNodeId && stateRef.current.selectionContext.selectedConnection == null);
		}

		if (editing) {
			// drawNode(ctx, [""], stateRef.current.mouseContext.x, stateRef.current.mouseContext.y, "idea", false)
		}
	}, [stateRef, drawNode, setCanvasDimensions, editing])

	useEffect(() => {
		drawTree()
	}, [drawTree])

	const setWebState = useCallback((newState) => {
		stateRef.current = newState
		setMirrorPosition()
		setDataInternal(newState.model)
	}, [setMirrorPosition])

	const handleMirrorChange = useCallback((text) => {
		updateMirror(text)

		if (stateRef.current.selectionContext.selectedNode) {
			stateRef.current.selectionContext.selectedNode.name = text
		} else if (stateRef.current.selectionContext.selectedConnection) {
			stateRef.current.selectionContext.selectedConnection.name = text
		} else {
			console.error("handleMirrorChange, No selection found to set text: " + text)
		}
		console.log(`Text: ${text}`);
		drawTree()
	}, [drawTree, updateMirror])

	const handleTransition = useCallback(newState => {
		newState = webService.handleTransition(getCtx(), stateRef.current, newState)

		let previousMouseState = stateRef.current.mouseState

		setWebState(newState)
		drawTree()

		if (previousMouseState !== webService.MouseState.DOWN_ON_MIRROR && previousMouseState !== webService.MouseState.UP && newState.mouseState === webService.MouseState.UP) {
			let selectedLocation = newState.selectionContext.selectedLocationNode
			if (selectedLocation != null) {
				console.log("Node selected. Setting mirror")
				handleMirrorChange(newState.selectionContext.selectedNode?.name)
				focus(mirrorRef.current)
			} else {
				let selectedConnection = newState.selectionContext.selectedConnection
				if (selectedConnection != null) {
					console.log("Connection selected. Setting mirror")
					handleMirrorChange(selectedConnection.name)
					focus(mirrorRef.current)
				}
			}
		}

	}, [stateRef, drawTree, handleMirrorChange, setWebState])

	const setAndGetCtx = useCallback(() => {
		let ctx = getCtx()
		ctxRef.current = ctx
		return ctx
	}, [])

	const onMouseDown = useCallback((e) => {
		console.log("MouseDown: " + e.type)
		let clickTime = Date.now()

		const ctx = setAndGetCtx()
		const rect = canvasRef.current.getBoundingClientRect(); // Get canvas position

		let [newX, newY] = webService.getClickCoordinates(rect, e)

		let clickedNodes = webService.findClickedNode(ctx, stateRef.current.model, newX, newY)
		let newState

		if (clickedNodes != null) {
			let [clickedNode, node, text] = clickedNodes
			console.log("Clicked: " + clickedNode.id + " " + text)
			console.log(stateRef.current.selectionContext.selectedLocationNode)
			if (stateRef.current.selectionContext.clickedId === clickedNode.id && clickTime - lastClickTimeRef.current < debounceInterval) {
				console.log("Same node: debounce skip")
			}

			console.log("clickedNodes", JSON.stringify(clickedNodes))
			newState = webService.updateStateWithMouseDownOnNode(stateRef.current, node.id, newX, newY)


			// clickedNodeRef.current = clickedNode

			// if (stateRef.current.selectionContext.selectedConnection == null) {
			// 	console.log("Set selected ref: " + clickedNode.id)
			// 	stateRef.current.selectionContext.selectedLocationNode = clickedNode
			// 	selectedNodeRef.current = node
			// 	handleMirrorChange(text)
			// 	setMirrorPosition(clickedNode.x, clickedNode.y)
			// }
			// clickOffsetXRef.current = newX - clickedNode.x
			// clickOffsetYRef.current = newY - clickedNode.y

		} else {
			newState = webService.updateStateWithMouseDownOnEmpty(stateRef.current, newX, newY)

			// clickedNodeRef.current = null
		}

		// console.log("mouseDown", "newState", JSON.stringify(newState))
		handleTransition(newState)

		drawTree()

		lastClickTimeRef.current = clickTime
		clearCtx()
	}, [canvasRef, stateRef, handleTransition, setAndGetCtx, drawTree])



	const onMouseUp = (e) => {

		let response = webService.updateStateWithMouseUp(stateRef.current)
		handleTransition(response)

		console.log("MouseUp","end", JSON.stringify(stateRef.current))
		// console.log("MouseUp")
		// isMouseDownRef.current = false
		// if (!isMouseDragRef.current) {
		// 	onCanvasClick(e)
		// }
		// isMouseDragRef.current = false
	}

	let lastMoveLog = 0
	const onMouseMove = (e) => {
		const rect = canvasRef.current.getBoundingClientRect(); // Get canvas position

		let [newX, newY] = webService.getClickCoordinates(rect, e)



		let time = Date.now()
		if (time - lastMoveLog > 1000) {
			lastMoveLog = time
			console.log("onMouseMove: " + newX + ", " + newY)
		}

		let response = webService.updateStateWithMouseMove(stateRef.current, newX, newY)

		handleTransition(response)

		// mousePositionRef.current = { x: newX, y: newY }

		// if (isMouseDownRef.current && clickedNodeRef.current != null) {
		// 	e.preventDefault()

		// 	stateRef.current.selectionContext.selectedLocationNode = clickedNodeRef.current
		// 	selectedNodeRef.current = dataRef.current.nodes.find(n => n.id === clickedNodeRef.current.id)

		// 	clickedNodeRef.current.x = Math.round(newX - clickOffsetXRef.current)
		// 	clickedNodeRef.current.y = Math.round(newY - clickOffsetYRef.current)
		// 	console.log(`Move: (${clickedNodeRef.current.x},${clickedNodeRef.current.y})`)
		// 	drawTree()
		// }

		drawTree()
	}

	// const onCanvasClick = (e) => {

	// 	let mirror = mirrorRef.current;
	// 	let canvas = e.target

	// 	console.log("Click action: " + actionRef.current)
	// 	const rect = canvas.getBoundingClientRect(); // Get canvas position
	// 	let newX = Math.round(e.clientX - rect.left);         // X coordinate within canvas
	// 	let newY = Math.round(e.clientY - rect.top);          // Y coordinate within canvas
	// 	console.log(`Clicked at: x=${newX}, y=${newY}`);
	// 	let locationNode = undefined;
	// 	if (clickedNodeRef.current == null) {

	// 		clickedNodeRef.current = getNode("", "field")
	// 		let newLocationData = { ...locationData }
	// 		locationNode = { id: clickedNodeRef.current.id, x: newX, y: newY }
	// 		let newData = { ...dataRef.current }
	// 		newData.nodes.push(clickedNodeRef.current)
	// 		newLocationData.nodes.push(locationNode)
	// 		setLocationData(newLocationData)
	// 		setData(newData)
	// 		newLocationData.nodes.push(locationNode)
	// 	} else {
	// 		locationNode = locationData.nodes.find(n => n.id === clickedNodeRef.current.id)
	// 	}
	// 	connect(stateRef.current.selectionContext.selectedLocationNode?.id, clickedNodeRef.current.id)
	// 	handleMirrorChange("")
	// 	setMirrorPosition(newX, newY)
	// 	focus(mirror)
	// 	stateRef.current.selectionContext.selectedLocationNode = locationNode
	// 	selectedNodeRef.current = clickedNodeRef.current

	// }

	// const connect = (previousId, newId) => {
	// 	console.log("Connect: " + previousId + " -> " + newId)

	// 	if (previousId === newId) {
	// 		return
	// 	}

	// 	if (previousId == null) {
	// 		stateRef.current.selectionContext.selectedConnection = null
	// 		return
	// 	}
	// 	let newData = { ...dataRef.current }
	// 	//check existing
	// 	let selectedConnection
	// 	for (let connection of newData.connections) {
	// 		if (connection.from === previousId && connection.to === newId) {
	// 			selectedConnection = connection
	// 		} else if (connection.to === previousId && connection.from === newId) {
	// 			console.log("reverse")
	// 			selectedConnection = connection
	// 			connection.from = previousId
	// 			connection.to = newId
	// 			setData(newData)
	// 		}
	// 	}
	// 	if (selectedConnection == null) {
	// 		selectedConnection = { from: previousId, to: newId, name: "" }
	// 		newData.connections.push(selectedConnection)
	// 		setData(newData)
	// 	}

	// 	stateRef.current.selectionContext.selectedConnection = selectedConnection
	// 	selectedNodeRef.current = selectedConnection
	// 	stateRef.current.selectionContext.selectedLocationNode = null
	// 	handleMirrorChange(selectedConnection.name)
	// }

	//Top Down Directions

	function roundToTwo(num) {
		return Math.round(num * 100) / 100;
	}


	function makeTree(array) {
		console.log("makeTree")
		let peak = undefined
		let parentMap = {}
		for (let item of array) {
			console.log(item);
			let level = item.lastIndexOf(".");
			if (level === -1) {
				continue;
			}
			console.log(level);
			let name;
			let type;
			if (item.search(",") === -1) {
				name = item.substring(level + 1)
				type = "field";
			} else {
				name = item.substring(level + 1, item.search(","));
				type = item.substring(item.search(",") + 1);
			}
			let node = getNode(name, type)
			if (level === 0) {
				peak = node;
			} else {
				parentMap[level - 1].nextNodes.push(node);
			}
			parentMap[level] = node
		}
		return peak
	}

	const focus = (mirror) => {
		mirror.focus()
	}

	const handleRadioButton = (event) => {
		actionRef.current = event.target.value
		stateRef.current.selectionContext.selectedLocationNode = null
		drawTree()
		setAction(event.target.value);
		if (event.target.value !== '1') {
			setMirrorPosition(0, 0)//hide mirror
		}

	};

	const exitEditor = () => {
		console.log("saving:" + JSON.stringify(stateRef.current.model))
		update({ data: stateRef.current.model })
		exit()
	}

	const onClickEdit = () => {
		edit()
	}

	const onClickCopyImage = async () => {
		try {
			const blob = await new Promise(resolve => canvasRef.current.toBlob(resolve, 'image/png'));
			const item = new ClipboardItem({ 'image/png': blob });
			await navigator.clipboard.write([item]);

			setCopyState("Copied!")
		} catch (err) {
			console.error('Failed to copy image:', err);
			setCopyState("Copy error!")
		}
	}

	const onClickDownloadImage = () => {
		const image = canvasRef.current.toDataURL('image/png'); // You can use 'image/jpeg' too

		const link = document.createElement('a');
		link.href = image;
		link.download = 'canvas-image.png'; // Filename for download
		link.click();
		setDownloadState("Downloaded!")
	}

	const onClickDelete = () => {
		if (stateRef.current.selectionContext.selectedConnection != null) {
			let newState = { ...stateRef.current }
			newState.model.connections = newState.model.connections.filter(c => {
				console.log("compare: " + JSON.stringify(c) + " : " + JSON.stringify(stateRef.current.selectionContext.selectedConnection) + " : " + (c !== stateRef.current.selectionContext.selectedConnection))
				return c !== stateRef.current.selectionContext.selectedConnection
			})
			newState.selectionContext = {}
			setWebState(newState)
		} else if (stateRef.current.selectionContext.selectedLocationNode != null) {
			
			console.log("deletingNode", "selection", JSON.stringify(stateRef.current.selectionContext.selectedLocationNode))
			console.log("deletingNode", "model", JSON.stringify(stateRef.current.model))

			let newState = { ...stateRef.current }
			newState.model.nodes = newState.model.nodes.filter(n => n.id !== stateRef.current.selectionContext.selectedLocationNode.id)
			newState.model.connections = newState.model.connections.filter(c => c.to !== stateRef.current.selectionContext.selectedLocationNode.id && c.from !== stateRef.current.selectionContext.selectedLocationNode.id)
			newState.model.locationNodes = newState.model.locationNodes.filter(n => n.id !== stateRef.current.selectionContext.selectedLocationNode.id)
			newState.selectionContext = {}

			console.log("deletingNode", "newstate", JSON.stringify(newState))
			setWebState(newState)
		}
		drawTree()
	}

	const getCtx = () => {
		return canvasRef.current.getContext('2d')
	}

	const clearCtx = () => {
		ctxRef.current = null
	}

	return (
		<div className='atomicdiv'>
			{editing ? <div id="radio-group">
				<label><input type="radio" name="choice" value="1" checked={action === "1"} onChange={handleRadioButton} />Add</label>
				<label><input type="radio" name="choice" value="2" checked={action === "2"} onChange={handleRadioButton} />Connect</label>
				<label><input type="radio" name="choice" value="3" checked={action === "3"} onChange={handleRadioButton} />Move</label>
				<button onClick={onClickDelete}>Delete</button>
				<button onClick={exitEditor}>Exit</button>
			</div>
				: <div>
					<button onClick={onClickEdit}>Edit</button>
					<button onClick={onClickCopyImage}>{copyState}</button>
					<button onClick={onClickDownloadImage}>{downloadState}</button>
				</div>
			}
			<div ref={canvasWrapperRef} className="canvas-wrapper">
				<canvas ref={canvasRef} id='canvas'></canvas>
			</div>
			<br />
			{editing ? <>
				<textarea ref={mirrorRef} id="mirror" value={mirrorText} onChange={(e) => handleMirrorChange(e.target.value)} />
				<div ref={mirrorSizeRef} id="mirrorsize">{mirrorText}</div>
			</>
				: null}
		</div>
	)
}

const getNode = (name, type) => {
	console.log("getNode")
	return {
		id: getUniqueId(),
		name: name,
		type: type
	}
}

const constructModel = (data, locationData) => {
	let model
	if (data == null) {
		model = { nodes: [], connections: [], locationNodes: [] }
	} else {
		model = data
	}
	if (locationData != null) {
		model.locationNodes = locationData.nodes
	}
	return model
}

function getUniqueId() {
	return Math.random().toString(36).substring(2, 5) + Date.now().toString(36);
}

export default Web